import React from 'react';

export function DropDownIcon() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="ml-2 bi bi-chevron-down" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
        </svg>
    )
}

export function TrashIcon() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-trash" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
            <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
        </svg>
    )
}

export function RightArrowIcon() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-arrow-right-short" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.793 8 8.146 5.354a.5.5 0 0 1 0-.708z" />
            <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8z" />
        </svg>
    )
}

export function TickIcon() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-check" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
        </svg>
    )
}

export function UserIcon() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" className=" mr-2 bi bi-person-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.468 12.37C12.758 11.226 11.195 10 8 10s-4.757 1.225-5.468 2.37A6.987 6.987 0 0 0 8 15a6.987 6.987 0 0 0 5.468-2.63z" />
            <path fill-rule="evenodd" d="M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
            <path fill-rule="evenodd" d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8z" />
        </svg>
    )
}

export function BookmarkIcon() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" className=" mr-2 bi bi-bookmark-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M3 3a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12l-5-3-5 3V3z" />
        </svg>
    )
}

export function FilterIcon() {
    return (
        <svg className="mr-2" width="1em" height="1em" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21 4.25C21 6.32107 19.3211 8 17.25 8C15.1789 8 13.5 6.32107 13.5 4.25C13.5 2.17893 15.1789 0.5 17.25 0.5C19.3211 0.5 21 2.17893 21 4.25ZM17.25 6.5C18.4926 6.5 19.5 5.49264 19.5 4.25C19.5 3.00736 18.4926 2 17.25 2C16.0074 2 15 3.00736 15 4.25C15 5.49264 16.0074 6.5 17.25 6.5Z" fill="#0F059E" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 11.75C10.5 13.8211 8.82107 15.5 6.75 15.5C4.67893 15.5 3 13.8211 3 11.75C3 9.67893 4.67893 8 6.75 8C8.82107 8 10.5 9.67893 10.5 11.75ZM6.75 14C7.99264 14 9 12.9926 9 11.75C9 10.5074 7.99264 9.5 6.75 9.5C5.50736 9.5 4.5 10.5074 4.5 11.75C4.5 12.9926 5.50736 14 6.75 14Z" fill="#0F059E" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21 19.25C21 21.3211 19.3211 23 17.25 23C15.1789 23 13.5 21.3211 13.5 19.25C13.5 17.1789 15.1789 15.5 17.25 15.5C19.3211 15.5 21 17.1789 21 19.25ZM17.25 21.5C18.4926 21.5 19.5 20.4926 19.5 19.25C19.5 18.0074 18.4926 17 17.25 17C16.0074 17 15 18.0074 15 19.25C15 20.4926 16.0074 21.5 17.25 21.5Z" fill="#0F059E" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.25 5H0V3.5H14.25V5ZM24 5H20.25V3.5H24V5Z" fill="#0F059E" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.25 20H0V18.5H14.25V20ZM24 20H20.25V18.5H24V20Z" fill="#0F059E" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 12.5H24V11H9.75V12.5ZM0 12.5H3.75V11H0V12.5Z" fill="#0F059E" />
        </svg>
    )
}

export function ChevronRight() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" className="ml-2 bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
        </svg>
    )
}

export function PlusCircleFill() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" className="mr-2 bi bi-plus-circle-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4a.5.5 0 0 0-1 0v3.5H4a.5.5 0 0 0 0 1h3.5V12a.5.5 0 0 0 1 0V8.5H12a.5.5 0 0 0 0-1H8.5V4z" />
        </svg>
    )
}
export function EditIcon() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" className="mr-2 bi bi-pencil-square" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
        </svg>
    )
}

export function PlusCircleFillIcon() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" className="mr-2 bi bi-plus-circle-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
        </svg>
    )
}
export function LeftArrowIcon() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" className=" mr-2 bi bi-arrow-left" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
        </svg>
    )
}

export function CloseIcon() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" className="close-icon ml-2 bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z" />
            <path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z" />
        </svg>
    )
}

export function ServerIcon() {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-server" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M1.333 2.667C1.333 1.194 4.318 0 8 0s6.667 1.194 6.667 2.667V4C14.665 5.474 11.68 6.667 8 6.667 4.318 6.667 1.333 5.473 1.333 4V2.667zm0 3.667v3C1.333 10.805 4.318 12 8 12c3.68 0 6.665-1.193 6.667-2.665V6.334c-.43.32-.931.58-1.458.79C11.81 7.684 9.967 8 8 8c-1.967 0-3.81-.317-5.21-.876a6.508 6.508 0 0 1-1.457-.79zm13.334 5.334c-.43.319-.931.578-1.458.789-1.4.56-3.242.876-5.209.876-1.967 0-3.81-.316-5.21-.876a6.51 6.51 0 0 1-1.457-.79v1.666C1.333 14.806 4.318 16 8 16s6.667-1.194 6.667-2.667v-1.665z" />
        </svg>
    )
}

export function Loading(){
    return(
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
        width="5rem" height="10rem" viewBox="0 0 40 40" enable-background="new 0 0 40 40" space="preserve">
        <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
          s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
          c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
        <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
          C22.32,8.481,24.301,9.057,26.013,10.047z">
          <animateTransform attributeType="xml"
            attributeName="transform"
            type="rotate"
            from="0 20 20"
            to="360 20 20"
            dur="0.5s"
            repeatCount="indefinite"/>
          </path>
        </svg>
    )
}